import { SerifTitle } from '../SerifTitle/SerifTitle'
import type { HorizontalCardTitleProps } from './HorizontalCardTitle.types'

export const HorizontalCardTitle = ({
  children,
}: HorizontalCardTitleProps): JSX.Element => {
  return (
    <SerifTitle as="span" size="sm" color="primary">
      {children}
    </SerifTitle>
  )
}
